import { Iterable, ICategoryTag, IPlace, ITag } from "types";

export const getBreaktimeForPlace = (
  place: Iterable<IPlace>,
  categoryTags: ICategoryTag[]
) => {
  let breaktime = 60; // minutes
  const placeTags = place.tags;

  const tagsWithBreakpointTimes = categoryTags
    .map((item) =>
      item.tags.map((i) => ({ name: i.name, breakTime: i.breakTime }))
    )
    .flat(1);

  const filtered = tagsWithBreakpointTimes
    .filter((item) => placeTags.includes(item.name))
    .sort((a, b) => b.breakTime - a.breakTime);

  if (filtered.length > 0) {
    breaktime = filtered[0].breakTime;
  }

  return breaktime;
};

export const setBreaktimes = (
  places: Iterable<IPlace>[],
  categoryTags: ICategoryTag[]
) => {
  return places.map((item) => ({
    ...item,
    breaktime: getBreaktimeForPlace(item, categoryTags),
  })) as Iterable<IPlace>[];
};

export const setBreaktime = (place: Iterable<IPlace>, tags: ITag[]) => {
  let breaktime = 60; // minutes;
  const includedIn = place.tags;

  const sortedByBreaktime = tags
    .filter((item) => includedIn.includes(item.name))
    .sort((a, b) => b.breakTime - a.breakTime);

  if (sortedByBreaktime.length > 0) {
    breaktime = sortedByBreaktime[0].breakTime;
  }

  return { ...place, breaktime };
};
